import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Form from "../../components/forms/ConfirmForm";
import {cancelRemoveCreditCard} from "../../actions/AccountApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class RemoveCreditCardFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { errors: [] }
  }

  handleSubmit(values) {
    return this.props.removePaymentMethod({accountId: this.props.accountId, paymentMethodId: this.props.paymentMethodId})
      .then((response) => {
        if (response.data.removePaymentMethod.errors.length <= 0) {
          this.props.cancelRemoveCreditCard();
        } else {
          let errors = createValidationErrors(response.data.removePaymentMethod.errors);
          this.setState({errors: errors});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err)});
      });      
  }

  handleCancel() {
    this.props.cancelRemoveCreditCard();
  }

  render() {
    return (
      <Form
        errors={this.state.errors}
        message="Are you sure you want to remove this card?"
        onSubmit={this.handleSubmit.bind(this)}
        onCancel={this.handleCancel.bind(this)}
        />
    )
  }
}

const REMOVE_CREDIT_CARD = gql`
  mutation removePaymentMethod($data: RemovePaymentMethodInput!) {
    removePaymentMethod(input: $data) {
      errors { key message }
    }
  }
`;

const withMutation = compose(
  graphql(REMOVE_CREDIT_CARD, {
    props: ({ mutate }) => ({
      removePaymentMethod: (data) => mutate({
        variables: { data: data }
      })
    })
  })
);

export default connect(null, {cancelRemoveCreditCard})(withMutation(RemoveCreditCardFormContainer));